module.exports = __webpack_public_path__ + "static/media/image_placeholder.abfa6e36.jpg";